import SportsHockeyIcon from '@mui/icons-material/SportsHockey';
import { withSeasonCheck } from '../../../config/withSeasonCheck';
import PlayerPropsPage from '../../../components/PlayerPropsPage/PlayerPropsPage';
import nhlRoutes from '../nhlRoutes';
import seoConfig from '../../../config/seo.json';

// Must stay in step with POLLING_CONFIG['icehockey_nhl']['props']['markets']
// in ev-adaptive-poller/config.py: a key listed here but not polled renders an
// empty tab, and one polled but missing here is paid for and never shown.
// test_every_polled_sport_actually_surfaces_its_props asserts every polled
// market appears in this array (not merely in the shared label map, which a
// market can satisfy while still having no tab here).
// Labels come from the shared map in src/utils/props.js (#194, #227).
const PROP_KEYS = [
  'player_points',
  'player_assists',
  'player_shots_on_goal',
  'player_goals',
];

const RELATED_MARKETS = [
  {
    title: 'NHL Moneylines',
    description: 'Straight-up winners priced against the FairLine.',
    to: '/nhl/moneyline',
    label: 'View Moneylines'
  },
  {
    title: 'NHL Puck Lines',
    description: 'Puck lines with consensus line comparison.',
    to: '/nhl/spread',
    label: 'View Puck Lines'
  },
  {
    title: 'NHL Totals',
    description: 'Game totals priced against sharp books.',
    to: '/nhl/total',
    label: 'View Totals'
  }
];

const NHLPlayerProps = () => (
  <PlayerPropsPage
    sport="nhl"
    seasonKey="NHL"
    apiEndpoint="/api/v2/nhl/player-props"
    propKeys={PROP_KEYS}
    sportRoutes={nhlRoutes}
    SportIcon={SportsHockeyIcon}
    seo={seoConfig?.nhl?.playerProps || { title: 'NHL Player Props +EV Analysis | +EV Bets' }}
    relatedMarkets={RELATED_MARKETS}
  />
);

export default withSeasonCheck(NHLPlayerProps, 'NHL', 'player-props');
